export const canCancelOrder = (status) => status === "PAYMENT_SUCCESS";

export const canDownloadInvoice = (status) =>
  //status === "PAYMENT_SUCCESS" || TODO: to be checked and removed later
  status === "DELIVERED" ||
  status === "PICKED" ||
  status === "SHIPPED" ||
  status === "PICK_UP" ||
  status === "PARTIALLY_PICKED" ||
  status === "PARTIALLY_SHIPPED" ||
  status === "REFUNDED" ||
  //status === "PARTIALLY_CANCELLED" || TODO: to be checked and removed later
  //status === "AWAITING_SHIPMENT" || TODO: to be checked and removed later
  //status === "CONFIRMED" || TODO: to be checked and removed later
  status === "IN_TRANSIT" ||
  status === "OUT_OF_DELIVERY" ||
  status === "PARTIALLY_DELIVERED";

export const canSeeTracking = (status) =>
  status !== "CANCELLED" &&
  status !== "PARTIALLY_CANCELLED" &&
  status !== "PAYMENT_FAILED" &&
  status !== "PAYMENT_CANCELLED" &&
  status !== "CREATED";

export const getOrderStatusFlags = (status) => ({
  cancelled: status === "PAYMENT_CANCELLED",
  failed: status === "PAYMENT_FAILED",
  pending: status === "PAYMENT_PENDING",
  success: status === "PAYMENT_SUCCESS",
});
